<select (ngModel)="specialty" name="specialty" id="specialty">
    <option value="">--</option>
    <option *ngFor="let c of ps.psSpecialties" value="{{ c.specialtyCode }}">{{ c.specialtyName }}</option>
</select>
